// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__wJcmH","topStart":"styles_topStart__VJLZo","topEnd":"styles_topEnd__LtpGp","bottomStart":"styles_bottomStart__r58Kl","bottomEnd":"styles_bottomEnd__1+VA1"};